export const changeLanguage = (payload) => ({type: 'CHANGE_LANGUAGE', payload})
export const changeTheme = (payload) => ({type: 'CHANGE_THEME', payload})
